module.exports = __webpack_public_path__ + "assets/img/761be4988af4f1cf8f991a571be6f4f1.png";